module.exports = __webpack_public_path__ + "static/media/Corp2.aa38800a.jpg";